<template>
  <div class="online-cv-wrapper">

    <!-- 创建在线简历入口 模块 -->
    <div class="no-online-cv-box" v-if="(cvInvisibileVisible || createOnlineCvVisible) && !banner.length">
      <p>将简历推荐给 HR<br />更易获得高质量 offer</p>
      <button @click="triggerCreateOnlineCvFunc()" data-growing-container data-growing-idx="305">试试推荐</button>
    </div>
    <div v-if="banner.length" class="banner-container" :class="{'more-banner': banner.length === 1}">
      <el-carousel >
        <el-carousel-item v-for="(item, index) in banner" :key="index" >
          <img :src="item.image" alt="" @click="openLink(item.link)">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="placeholder" v-if="(cvInvisibileVisible || createOnlineCvVisible) || banner.length"></div>

    <!-- 在线简历展示 模块 -->
    <div class="online-cv-box" v-if="onlineCvModuleVisible">

      <div class="online-cv-header">
        <h6>简历推荐中</h6>
        <div class="online-cv-icon-box">
          <!-- 更换简历 -->
          <i class="iconfont icongenghuanjianli" v-if="effectiveCvVisible" @click="debounce(() => { triggerToggleOnlineCvFunc() }, 300)"></i>
          <!-- 去隐私页 -->
          <i class="iconfont iconyinsishezhi1" @click="toSetPrivacyPageFunc()"></i>
        </div>

      </div>

      <div class="online-cv-content" @click="triggerShowOnlineCvDetailFunc()">

        <div class="online-cv-content-left">
          <img class="online-cv-avatar" :src="onlineCvData.resume.info.profile.avatar_url || personInfo.avatar_url || 'https://wondercv-public-resource.oss-cn-beijing.aliyuncs.com/avatars/avatars4.png'" alt="">
          <div class="online-cv-info">
            <span class="online-cv-title">{{ onlineCvData.resume.info.profile.username }}</span>

            <template v-if="isStudent && onlineCvData.resume.info && onlineCvData.resume.info.education_experiences && onlineCvData.resume.info.education_experiences.length">
              <span class="online-cv-tag orange school" v-if="onlineCvData.resume.info.education_experiences[0].cust_uni_name || onlineCvData.resume.info.education_experiences[0].school.cn">{{ onlineCvData.resume.info.education_experiences[0].cust_uni_name || onlineCvData.resume.info.education_experiences[0].school.cn }}</span>
              <span class="online-cv-tag degree" v-if="onlineCvData.resume.info.education_experiences[0].cust_degree || onlineCvData.resume.info.education_experiences[0].degree_name.cn">{{ onlineCvData.resume.info.education_experiences[0].cust_degree || onlineCvData.resume.info.education_experiences[0].degree_name.cn }}</span>
            </template>
            <template v-if="!isStudent && onlineCvData.resume.info && ((onlineCvData.resume.info.work_experiences && onlineCvData.resume.info.work_experiences.length) || (onlineCvData.resume.info.internship_experiences.length))">
              <span class="online-cv-tag">{{ (onlineCvData.resume.info.work_experiences[0] || onlineCvData.resume.info.internship_experiences[0]) | workTitleFilter }}</span>
            </template>

            <span class="online-cv-time">{{ moment(onlineCvData.resume.updated_at).format('YYYY年MM月DD日 HH:mm') }}</span>
          </div>
        </div>

        <div class="online-cv-content-right">
          <button class="online-cv-btn update" v-if="isUpdated || isPerfect" @click.stop="debounce(() => { triggerUpdateOnlineCvFunc() }, 300)">更新</button>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import moment from 'moment'
import { routerTo } from '@/assets/js/util'
import { mapState } from 'vuex'
import { componentsMixin } from '@/assets/js/mixins/components'
import api from "@/api";

export default {
  props: {
    // 当前在线简历对应草稿简历是否有更新
    isUpdated: {
      type: Boolean,
      default: false
    },
    // 是否完善信息
    isPerfect: {
      type: Boolean,
      default: false
    },
    // 显示跳转到开启隐私按钮
    cvInvisibileVisible: {
      type: Boolean,
      default: false
    },
    // 显示创建在线简历入口
    createOnlineCvVisible: {
      type: Boolean,
      default: false
    },
    // 显示在线简历模块
    onlineCvModuleVisible: {
      type: Boolean,
      default: false
    },
    // 是否是学生
    isStudent: {
      type: Boolean,
      default: false
    },
    // 在线简历数据
    onlineCvData: {
      type: Object,
      default: {}
    }
  },
  mixins: [ componentsMixin ],
  data () {
    return {
      moment,
      banner: []
    }
  },
  filters: {
    workTitleFilter(val) {
      if (!val) return
      return val.title
    }
  },
  computed: {
    ...mapState('cv', [ 'cvs' ]),
    ...mapState('me', [ 'personInfo' ]),

    // 是否有可生成在线简历的草稿简历（不是导师简历、可编辑简历、中文简历）
    effectiveCvVisible () {
      let arr = []
      for (let i = 0; i < this.cvs.length; i++) {
        if (!this.cvs[i].is_mentor && this.cvs[i].lang === 'cn' && this.cvs[i].can_editable) {
          // 拿到可以成为在线简历的可用简历列表
          arr.push(this.cvs[i])
        }
      }
      return arr.length > 1
    }

  },
  created() {
    this.getBannerList()
  },
  methods: {
    // 点击banner
    openLink(link) {
      if (link) {
        window.open(link)
      }
    },
    // 获取banner
    async getBannerList() {
      let res = await api.jobs.getBanner({ position: '133' });
      console.log(res, "===================>resss")
      if(res.data.length) {
        this.banner = res.data || [];
      }
    },
    // 触发 切换在线简历函数
    triggerToggleOnlineCvFunc () {
      this.$emit('triggerToggleOnlineCvFunc')
    },
    // 触发 创建在线简历函数
    triggerCreateOnlineCvFunc () {
      this.$emit('triggerCreateOnlineCvFunc')
    },
    // 触发 更新在线简历函数
    triggerUpdateOnlineCvFunc () {
      this.$emit('triggerUpdateOnlineCvFunc')
    },
    // 触发 显示在线简历详情函数
    triggerShowOnlineCvDetailFunc () {
      this.$emit('triggerShowOnlineCvDetailFunc')
    },
    // 跳转 隐私设置页
    toSetPrivacyPageFunc () {
      routerTo('/account/users?index=2', '_blank')
    }
  }
}
</script>

<style lang="sass" scoped>
  @import "./index.scss";
</style>
